import { render, staticRenderFns } from "./RepliesView.vue?vue&type=template&id=52fe536d&scoped=true&"
import script from "./RepliesView.vue?vue&type=script&lang=js&"
export * from "./RepliesView.vue?vue&type=script&lang=js&"
import style0 from "./RepliesView.vue?vue&type=style&index=0&id=52fe536d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe536d",
  null
  
)

export default component.exports